import React from 'react';
import { motion } from 'framer-motion';
import { Trophy } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-surface" data-id="element-251">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-253">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl shadow-primary/5 border border-primary/10 relative overflow-hidden" data-id="element-254">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-255" />

            <div className="relative z-10" data-id="element-256">
              <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-primary/20 text-white" data-id="element-257">
                <Trophy className="w-8 h-8" data-id="element-258" />
              </div>

              <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-4" data-id="element-259">
                🏆 MEGAPACK OPERATIVO AIRBNB MANAGER
              </h3>

              <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-260">
                <span className="px-4 py-1.5 bg-primary/10 text-primary font-bold rounded-full text-sm" data-id="element-261">
                  6 Tomos + 6 Bonos
                </span>
                <span className="px-4 py-1.5 bg-secondary/10 text-secondary font-bold rounded-full text-sm" data-id="element-262">
                  Sin propiedad propia
                </span>
                <span className="px-4 py-1.5 bg-green-100 text-green-700 font-bold rounded-full text-sm" data-id="element-263">
                  Con ingresos en USD
                </span>
              </div>

              <p className="text-xl text-gray-600 font-medium" data-id="element-264">
                Todo resuelto.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}